import React from 'react';

import styles from './Configurator.module.css';

import TitleScreen from './TitleScreen';
import BundlesScreen from './BundlesScreen';
import ConfigureOwnScreen from './ConfigureOwnScreen';
import FooterScreen from './FooterScreen';
import { ModalConsumer } from '../Modal/ModalContext';

const Configurator = () => {

  return (
    <ModalConsumer>
      {({showModal}) => (
        <div className={styles['wrapper']}>
          <TitleScreen/>
          <BundlesScreen showModal={showModal}/>
          <ConfigureOwnScreen showModal={showModal}/>
          <FooterScreen showModal={showModal}/>
        </div>
      )}
    </ModalConsumer>
  );
  
};

export default Configurator;
